import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-lg-8 col-md-12 blog-main" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)

import { reactive } from 'vue';
import Sidebar from '@/blog/components/shared/Sidebar.vue';
import PostBreadcrumb from '@/blog/components/post/PostBreadcrumb.vue';
import PostCover from '@/blog/components/post/PostCover.vue';
import PostBody from '@/blog/components/post/PostBody.vue';
import PostMeta from '@/blog/components/post/PostMeta.vue';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const img = reactive({
  cover: require('@/blog/assets/img/blog-cover.png'),
});
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const mainApp: any = document.querySelector('#app');
// console.log(typeof mainApp);

mainApp.style.backgroundImage = 'unset';

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(PostBreadcrumb),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(PostCover, {
            cover: _unref(img).cover
          }, null, 8, ["cover"]),
          _createVNode(PostBody),
          _hoisted_4,
          _createVNode(PostMeta)
        ]),
        _createVNode(Sidebar, { class: "" })
      ])
    ])
  ], 64))
}
}

})